import { getLocationsByUser } from 'core/service/locations/location-by-user.service';
import { AccessState, BaseLocation } from 'core/contexts/locations/location.model';
import { locationKeys } from 'core/query-client/keys/location.keys';
import { updateQuery } from 'core/query-client/query-client';
import { executeRequest } from 'core/utils/backend-service';
import { usePocQuery } from './use-poc-query.hook';

const updateLocations = () => updateQuery(locationKeys.byUser());

export const useLocations = () => {
    const { data, isLoading, isError, error } = usePocQuery({
        queryKey: locationKeys.byUser(),
        queryFn: () => executeRequest(() => getLocationsByUser()),
    });

    const locations = data?.locations ?? [];
    const accessState: AccessState = data?.accessState ?? 'FULL';

    const getLocationsFirstLevelFromSecondLevel = (locationIds: string[]): BaseLocation[] => {
        const locs = locations
            .flatMap((loc) => loc.children)
            .filter((childLoc) => locationIds.includes(childLoc!.id))
            .map((childLoc) => childLoc!.parentLocation);

        const parentLocs = [...new Map(locs.map((loc) => [loc!.id, loc])).values()];

        return parentLocs as BaseLocation[];
    };

    return {
        isLoading,
        isError,
        error,
        locations,
        accessState,
        updateLocations,
        getLocationsFirstLevelFromSecondLevel,
    };
};
